import React, { useState } from 'react';
import { Modal, Button, Form, Alert } from 'react-bootstrap';
import { customSaveBankInfo } from '../applicationuser/list/core/_requests';

const BankInfoPopup: React.FC = () => {
    const [show, setShow] = useState<boolean>(true);
    const [bank, setBank] = useState<string>('');         // bankName -> bank
    const [branch, setBranch] = useState<string>('');     // bankBranch -> branch
    const [iban, setIban] = useState<string>('');
    const [error, setError] = useState<string>('');

    const validateIBAN = (iban: string): boolean => {
        return iban.startsWith('TR') && iban.replace(/\s/g, '').length === 26;
    };

    const formatIBAN = (value: string) => {
        const cleaned = value.replace(/\s+/g, '').toUpperCase();
        return cleaned.replace(/(.{4})/g, '$1 ').trim();
    };

    const handleIBANChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const formattedIBAN = formatIBAN(event.target.value);
        if (formattedIBAN.length <= 32) {
            setIban(formattedIBAN);
        }
    };

    const handleSave = async () => {
        if (!validateIBAN(iban)) {
            setError('IBAN "TR" ile başlamalı ve 26 haneli olmalıdır.');
            return;
        }

        try {
            const response = await customSaveBankInfo({
                bank,
                branch,
                iban
            });
            console.log('API Response:', response);
            setShow(false);
            setError('');
        } catch (error) {
            console.error('Banka bilgileri kaydedilirken hata oluştu:', error);
            setError('Banka bilgileri kaydedilirken bir hata oluştu.');
        }
    };

    return (
        <Modal show={show} onHide={() => { }} backdrop="static" keyboard={false}>
            <Modal.Header closeButton>
                <Modal.Title>Banka Bilgileri</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {error && <Alert variant="danger">{error}</Alert>}
                <Alert variant="warning">
                    Sistemi kullanabilmeniz için banka bilgilerinizi girmeniz gerekmektedir. Girdiğiniz hesap numarası size ait olmalıdır yoksa ödeme yapılması mümkün değildir.
                </Alert>
                <Form>
                    <Form.Group>
                        <Form.Label>Banka Adı</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Banka Adını Girin"
                            value={bank}
                            onChange={(e) => setBank(e.target.value)}
                        />
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>Şube Adı</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Şube Adını Girin"
                            value={branch}
                            onChange={(e) => setBranch(e.target.value)}
                        />
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>IBAN</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="IBAN Girin"
                            value={iban}
                            onChange={handleIBANChange}
                        />
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={handleSave}>Kaydet</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default BankInfoPopup;
